module.exports = "/remote-dist/62f48f0dcf07a9ebbe0aed892f3de9dc.jpg";